import React, { useCallback, useEffect, useState } from 'react';
import { PrinterOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Table, Select, Row, Col, Flex } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  AButton,
  PageIntro,
  PageLayout,
  PagePanel,
} from '../../../../../components';
import { useToast } from '../../../../../hooks/toast';
import api from '../../../../../services/api';
import { IClient } from '../../../../../shared/interfaces';

const { Option } = Select;

const ClientReportBirthdays: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<IClient[]>([]);
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);

  const loadReport = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/clients/reports/birthdays', {
        params: { month },
      });
      setClients(response.data);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Erro ao carregar o relatório de Aniversariantes',
      });
    } finally {
      setLoading(false);
    }
  }, [month, addToast]);

  useEffect(() => {
    loadReport();
  }, [loadReport]);

  const columns = [
    {
      title: 'Código',
      dataIndex: 'code',
      width: 100,
    },
    {
      title: 'Nome',
      dataIndex: 'corporate_name',
    },
    {
      title: 'Celular',
      dataIndex: 'cell_phone',
    },
    {
      title: 'Data Nasc.',
      dataIndex: 'birthday',
      render: (val: string) => (val ? new Date(val).toLocaleDateString() : '-'),
    },
  ];

  return (
    <PageLayout>
      <PageIntro
        badge="Relatórios"
        icon={<PrinterOutlined />}
        title="Aniversariantes"
        description="Consulte os pacientes aniversariantes do mês selecionado em uma visualização alinhada ao novo padrão."
        actions={
          <Flex>
            <AButton
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/clients')}
            >
              Voltar
            </AButton>
            <AButton
              type="primary"
              icon={<PrinterOutlined />}
              onClick={() =>
                navigate(`/clients/reports/birthdays/print?month=${month}`)
              }
            >
              Imprimir
            </AButton>
          </Flex>
        }
      />
      <PagePanel>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Select
              style={{ width: '100%' }}
              value={month}
              onChange={(val) => setMonth(val)}
              placeholder="Selecione o mês"
            >
              <Option value={1}>Janeiro</Option>
              <Option value={2}>Fevereiro</Option>
              <Option value={3}>Março</Option>
              <Option value={4}>Abril</Option>
              <Option value={5}>Maio</Option>
              <Option value={6}>Junho</Option>
              <Option value={7}>Julho</Option>
              <Option value={8}>Agosto</Option>
              <Option value={9}>Setembro</Option>
              <Option value={10}>Outubro</Option>
              <Option value={11}>Novembro</Option>
              <Option value={12}>Dezembro</Option>
            </Select>
          </Col>
        </Row>
        <br />
        <Table
          dataSource={clients}
          columns={columns}
          rowKey="id"
          pagination={false}
          loading={loading}
          bordered
          size="small"
        />
      </PagePanel>
    </PageLayout>
  );
};

export default ClientReportBirthdays;
